import React from 'react';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import AdminNavigation from './AdminNavigation';
import './AdminPage.css';

/**
 * Frame for every admin tool: shared shell without the site sidebar,
 * section switcher, then the giant section title with its actions.
 */
const AdminLayout = ({ eyebrow, title, lead, actions, children, className = '', mainClassName = '' }) => (
    <PageShell
        className={['admin-page-app', className].filter(Boolean).join(' ')}
        mainClassName={['admin-shell', mainClassName].filter(Boolean).join(' ')}
    >
        <AdminNavigation />
        {title ? <PageHeader eyebrow={eyebrow} title={title} lead={lead} actions={actions} className="admin-page-header" /> : null}
        {children}
    </PageShell>
);

export default AdminLayout;
